"use client";

import { AlertCircle, ChevronDown } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ShopifyReconnectButton } from "./shopify-reconnect-button";
import { useShopifyConnectionStatus } from "@/hooks/use-shopify-connection-status";
import type { ShopSummary } from "@/types/shop";

export function ShopifyReconnectCallout({ shop }: { shop: ShopSummary }) {
  const { data: reconnectRequired } = useShopifyConnectionStatus(
    shop.id,
    shop.shopType === "SHOPIFY",
    shop.shopifyReconnectRequired,
  );
  if (shop.shopType !== "SHOPIFY" || !shop.domain || !reconnectRequired)
    return null;
  return (
    <Collapsible
      role="alert"
      className="rounded-md border border-amber-200 bg-amber-50 text-amber-950"
    >
      <CollapsibleTrigger className="group flex w-full items-start gap-2 rounded-md p-3 text-left text-xs font-medium leading-5 hover:bg-amber-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-amber-600">
        <AlertCircle className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
        <span className="flex-1">Your Shopify connection needs attention</span>
        <ChevronDown
          className="mt-0.5 size-4 shrink-0 transition-transform group-data-[state=open]:rotate-180"
          aria-hidden="true"
        />
      </CollapsibleTrigger>
      <CollapsibleContent className="space-y-3 px-3 pb-3 text-xs leading-relaxed">
        <p>
          Jurni can’t access your Shopify store with the current connection.
          Reconnect to restore access to your store.
        </p>
        <ShopifyReconnectButton shopDomain={shop.domain} size="sm" />
      </CollapsibleContent>
    </Collapsible>
  );
}
